import config from "../config";

const fetchProvinces = async (
  limit = 15,
  skip = 0,
  search = "",
  field = "", // "name" or "code"
  countryId = "", // country ID
  codes = [] // array of province codes
) => {
  let query = `$populate=country&$limit=${limit}&$skip=${skip}`;

  if (search?.trim() && field) {
    query += `&${field}[$search]=${search.trim()}`;
  }

  if (countryId) {
    query += `&country=${countryId}`;
  }

  if (codes.length > 0) {
    query += codes.map((code) => `&code[$in][]=${code}`).join("");
  }

  const url = `${config.coreUrl}/province?${query}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch provinces");
  }

  const json = await response.json();

  return {
    total: json.total,
    skip: json.skip,
    limit: json.limit,
    data: json.data,
  };
};

export default fetchProvinces;
